import First from "../../layouts/Footer/First";
import React from "react";

function FooterUi() {
  return (
    <div className="flex w-full h-auto max-w-full gap-3 pb-7">
      <First />

    </div>
  )
}

export default FooterUi;
